var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.615 7.154A.789.789 0 1 1 10.5 6.04l1.115-1.115a3.154 3.154 0 0 1 4.461 4.46l-2.788 2.789a3.154 3.154 0 0 1-4.46 0 .789.789 0 1 1 1.114-1.115 1.577 1.577 0 0 0 2.23 0l2.789-2.788a1.577 1.577 0 0 0-2.23-2.23zm-2.23 6.692A.789.789 0 1 1 10.5 14.96l-1.115 1.115a3.154 3.154 0 1 1-4.461-4.46l2.788-2.789a3.154 3.154 0 0 1 4.46 0 .789.789 0 1 1-1.114 1.115 1.577 1.577 0 0 0-2.23 0L6.038 12.73a1.577 1.577 0 0 0 2.23 2.23z"
})));
export default SvgLink;